import type { HeroDemoSurface } from '@/lib/content';

/**
 * Miniatures of each assistant's own chat canvas, not our marketing theme. The hexes follow the
 * public ChatGPT and Claude.ai light UIs, so matching them to our tokens would break the effect —
 * they are the one place in the app where a raw colour is correct.
 *
 * `panel`/`bubble*` are the colour-only pair, for a surface that brings its own geometry; the rest
 * carry the hero funnel's shapes too.
 */
export const CHAT_SKINS = {
  ChatGPT: {
    panel: 'bg-[#f7f7f8]',
    bubbleUser: 'bg-[#ececec] text-[#0d0d0d]',
    bubbleAgent: 'border-[#e5e5e5] bg-white text-[#0d0d0d]',
    ask: 'max-w-[80%] self-end rounded-[22px] bg-[#ececec] px-3 py-2 text-sm leading-snug text-[#0d0d0d]',
    reply:
      'flex w-full flex-col gap-2.5 rounded-2xl border border-[#e5e5e5] bg-white p-2.5 text-[#0d0d0d]',
    price:
      'rounded-full border border-[#e5e5e5] bg-[#f7f7f8] px-2.5 py-0.5 font-mono text-xs whitespace-nowrap text-[#5d5d5d]',
    cta: 'rounded-full bg-[#0d0d0d] px-3.5 py-2 text-center text-sm font-medium text-white',
  },
  Claude: {
    panel: 'bg-[#f4f0e7]',
    bubbleUser: 'bg-[#e7dfd2] text-[#141413]',
    bubbleAgent: 'border-[#e0d5c5] bg-[#fbf7f0] text-[#141413]',
    ask: 'max-w-[80%] self-end rounded-xl bg-[#e7dfd2] px-3 py-2 text-sm leading-snug text-[#141413]',
    reply:
      'flex w-full flex-col gap-2.5 rounded-xl border border-[#e0d5c5] bg-[#fbf7f0] p-2.5 text-[#141413]',
    price:
      'rounded-md border border-[#e0d5c5] bg-[#f4f0e7] px-2.5 py-0.5 font-mono text-xs whitespace-nowrap text-[#6b6459]',
    cta: 'rounded-lg bg-[#d97757] px-3.5 py-2 text-center text-sm font-medium text-white',
  },
} as const;

export type ChatSkin = (typeof CHAT_SKINS)[HeroDemoSurface];
